import React, { useEffect, useState } from "react";
import {
  Chip,
  Typography,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import ReusabletableComponent from "../../../components/ReusabletableComponent";
import { BOOKING_FORM_STATUS, COMPARE_VALUE } from "../../../config/constant";
import Header from "../../../layout/header/Header";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getMultiBookingList,
  resetMultiBookingListData,
} from "../new-booking-form.slice";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import linkIcon from "../../../assets/icons/linkicon.svg";

const MutliUnitBookingsTable = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { groupId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const DEBOUNCE_DELAY = 400;
  const isMobile = useMediaQuery("(max-width:600px)");

  const { isLoading, multiBookingListData } = useSelector(
    (state) => state.newBookingForm
  );
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    if (!groupId) return;

    const handler = setTimeout(() => {
      dispatch(
        getMultiBookingList({
          groupId,
          page: page + 1,
          limit: pageSize,
          search: searchText,
        })
      );
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [searchText, page, pageSize, groupId, dispatch]);

  useEffect(() => {
    if (groupId) {
      dispatch(
        getMultiBookingList({ groupId, page: page + 1, limit: pageSize })
      );
    }
    return () => dispatch(resetMultiBookingListData());
  }, [dispatch, groupId, page, pageSize]);

  const bookingList = multiBookingListData?.opportunities?.map((oppo) => ({
    ...oppo,
    id: oppo.Id, // map BE's Id to lowercase 'id'
  }));

  const totalRecords = multiBookingListData?.totalRecords || 0;

  const getBgColor = (status) => {
    switch (status) {
      case BOOKING_FORM_STATUS.NEW:
        return "#8E33FF29"; // Light purple
      case BOOKING_FORM_STATUS.IN_PROGRESS:
        return "#FFAB0029"; // warm yellow
      case BOOKING_FORM_STATUS.NOT_SIGNED:
        return "#FF563029"; // Light red
      case BOOKING_FORM_STATUS.SIGNED:
        return "#FF563029"; // need to change
      case BOOKING_FORM_STATUS.SIGNED_OFFLINE:
        return "#22C55E29"; // Light green
      default:
        return "#00B8D929"; // Light blue
    }
  };

  const getTextColor = (status) => {
    switch (status) {
      case BOOKING_FORM_STATUS.NEW:
        return "#5119B7"; // purple
      case BOOKING_FORM_STATUS.IN_PROGRESS:
        return "#B76E00"; // yellow
      case BOOKING_FORM_STATUS.NOT_SIGNED:
        return "#B71D18"; // red
      case BOOKING_FORM_STATUS.SIGNED:
        return "#FF563029"; // need to change
      case BOOKING_FORM_STATUS.SIGNED_OFFLINE:
        return "#118D57"; // green
      default:
        return "#006C9C"; // blue
    }
  };

  const columns = [
    { field: "Project", headerName: "Project Name", flex: 1, width: 150 },
    { field: "unitno", headerName: "Unit #", flex: 1.1, width: 150 },
    {
      field: "SalesValue",
      headerName: "Sale Value",
      flex: 0.8,
      width: 100,
      renderCell: (params) => (
        <Typography sx={{ fontSize: "14px" }}>
          {params?.value ? Number(params?.value).toLocaleString("en-IN") : "-"}
        </Typography>
      ),
    },
    {
      field: "Amount",
      headerName: "Booking Amount",
      flex: 0.8,
      width: 150,
      renderCell: (params) => (
        <Typography sx={{ fontSize: "14px" }}>
          {params?.value ? Number(params?.value).toLocaleString("en-IN") : "-"}
        </Typography>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1.3,
      width: 150,
      renderCell: (params) => (
        <Chip
          size="small"
          label={params.value}
          sx={{
            borderRadius: "6px",
            backgroundColor: getBgColor(params.value),
            color: getTextColor(params.value),
            fontWeight: 550,
            border: "none",
          }}
        />
      ),
    },
    {
      field: "Name",
      headerName: "Primary Applicant",
      flex: 1,
      width: 150,
    },
    {
      field: "Id",
      headerName: "Link",
      flex: 0.4,
      width: 150,
      renderCell: (params) => (
        <IconButton onClick={() => handleCopyLink(params?.row)}>
          <img
            src={linkIcon}
            alt="Copy Link"
            style={{ width: 22, height: 22 }}
          />
        </IconButton>
      ),
    },
  ];

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  // const handleCopyLink = (id) => {
  // const baseUrl = window.location.origin;
  // const bookingLink = `${baseUrl}/booking-form/${id}`;

  // navigator.clipboard.writeText(bookingLink)
  //   .then(() => {
  //     setSnackBarconfig({
  //       open: true,
  //       message: "Booking form link copied to clipboard!",
  //       severity: "success",
  //     });
  //   })
  //   .catch((err) => {
  //     setSnackBarconfig({
  //       open: true,
  //       message: "Failed to copy link. Please try again.",
  //       severity: "error",
  //     });
  //   });
  // };

  const handleCopyLink = (row) => {
    if (
      multiBookingListData?.isFirstFormFilled &&
      row?.status === BOOKING_FORM_STATUS.NEW
    ) {
      history.push(`/applicant-mapping/${groupId}?oppId=${row?.id}`);
    } else {
      history.push(`/booking-form/${row?.id}`);
    }
  };
  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Header logo={COMPARE_VALUE?.Puravankara} showHamburger={false} />
      <Box sx={{ p: isMobile ? "16px" : "24px 80px 24px 80px" }}>
        <Typography sx={{ fontWeight: 600, fontSize: "22px", mb: 1 }}>
          Booking Details
        </Typography>
        <ReusabletableComponent
          columns={columns}
          rows={bookingList || []}
          searchPlaceholder="Search by Applicant Name, Project Name or Unit Number"
          loading={isLoading}
          rowCount={totalRecords}
          page={page}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          onSearchChange={setSearchText}
          searchText={searchText}
        />
      </Box>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default MutliUnitBookingsTable;
